/* eslint-disable no-restricted-globals */
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        module: '.rfct-select',
        select: '.rfct-select__select',
    },
};

export default class Select {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = this._getDomElements();
    }

    _getDomElements() {
        return {
            $select: this._$rootElement.find(config.selectors.select),
        };
    }

    init() {
        this._elements.$select.niceSelect();
    }
}

moduleRegistry.registerModule('Select', Select);
moduleRegistry.autoApplyModule('Select', config.selectors.module);
